import { useCallback, useEffect, useState } from 'react';
import { useNavigation, StackNavigationProp } from '@betty/navigation';
import { logError } from '@betty/toolkit/logging';
import { WebViewProps } from '@betty/moonlight';
import { DepositNavigatorParamsList } from '../navigators/DepositNavigator/DepositNavigator.types';
import { WithdrawNavigatorParamsList } from '../navigators/WithdrawNavigator/WithdrawNavigator.types';
import { handleRestrictedFunctionality } from '../utils/payments';
import PaymentService from '../services/PaymentService/PaymentService';
import usePaymentResult from './usePaymentResult/usePaymentResult';

type NavigatorParamsList =
  | DepositNavigatorParamsList
  | WithdrawNavigatorParamsList;

const usePaymentLaunch = (type: 'deposit' | 'withdrawal', data?: object) => {
  const navigation = useNavigation<StackNavigationProp<NavigatorParamsList>>();
  const [source, setSource] = useState<WebViewProps['source']>();

  const fetch = useCallback(async () => {
    try {
      const { url } = await PaymentService.getPaymentUrl({
        data: {
          paymentMethod: 'Card',
          ...data,
        },
        pathParams: { type },
      });

      // TODO: change to uri once the backend is ready
      setSource({
        html: `
          <html>
          <head>
            <script>window.onload = function() { window.location.href = "${url}"}</script>
          </head>
          <body></body>
          </html>
      `,
      });

      return data;
    } catch (error) {
      logError('Payment url request failure.', error, { type });

      handleRestrictedFunctionality(error);
    }
  }, [type, data]);

  const onPaymentResult = useCallback(
    (transactionId?: string) => {
      if (transactionId) {
        navigation.replace('PaymentStatusScreen', {
          externalTransactionId: transactionId,
        });
      }
    },
    [navigation],
  );

  const handlers = usePaymentResult(onPaymentResult);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return {
    source,
    scrollEnabled: true,
    ...handlers,
  };
};

export default usePaymentLaunch;
